module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAABHklEQVR4AeyT0Q3CMAxEWyaADdmAbgBMgBiBCWEDcxb9qhLsSK1jwaFYIq5dn+/BbvixDxfKDpSESCjYAf7kgg1vHkdCzZYFN5BQsOHN40io2bLgBhIKNrx5HAk1WxbcQEJrGr7Fu0hoC1fXfOf/EhKRs4g85RM3r6uoD+1zEYIoXeCCJfZzTMjpHdf6QU1onypxLYTCI2J5TstE4R7dN3gXKmjNmfIudC/IfxRyy1R0n4/QOI76f1FxLyjWuCI34fvXg5rQPhXjJTRA3IQ4zKFCtd8M1If2uRcylScp4EJJQFRlkFDVmiQPSCgJiKoMEqpak+SBm1ASvaYMLmRa1LmAhDoDMMeTkGlR5wIS6gzAHE9CpkWdC0ioMwBz/BsAAP//5f6cmQAAAAZJREFUAwCh1FppvQ/kwAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/denglu_yanzhengma@2x.png
// module id = 881
// module chunks = 1